import { CONFIG_UPDATE, type ConfigActions, type ConfigState } from './types';

const initialState: ConfigState = {
  adultAges: {},
  checkAllowedCountries: false,
  allowedCountries: [],
  validation: {
    identity: [],
  },
};

export const configReducer = (
  state = initialState,
  action: ConfigActions,
): ConfigState => {
  switch (action.type) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    case CONFIG_UPDATE:
      return {
        ...state,
        ...action.config,
      };
    default:
      return state;
  }
};
